<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vz4Ot0/media/FC-9781035814435.jpg?1708093998581" alt="This image is the cover for the book Physics, Fractals and Flowers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Physics, Fractals and Flowers
      </h1>
      <p class="bookDescription body article font2">
        <p>At the core of scientific thought lies a fundamental misconception, one that has kept humanity ensnared in what future generations will dub the ‘Aeons of Ignorance.’ This book unveils this profound oversight, introducing a ‘foundational grand narrative’ that harmonizes the realms of science. Dive into the exploration of a long-anticipated unifying theory, rooted in a singular, recurring pattern. “Surely underneath it all is something so beautiful, so simple, that when we find it in a decade, a century, or a millennium, we will all turn to each other and say, how can it have been otherwise, how can we have been so stupid?” – John Wheeler, physicist</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Peter Anthony Cook
      </h2>
      
      <p class="authorDescription body article">Peter Cook is an engineer, educator, writer, inventor and problem solver, whose exploits have been well documented in the press. Between 1996 and 2000, he co-founded and ran PJT Dynamics, an engineering company that specialised in finding solutions to well-known motorcycle flaws. Whilst working on race engines, he started to tackle the problem of turbulence within systems. Turbulence is one of the great unsolved problems in science, because by definition turbulence is unpredictable, and the laws of classical physics are by definition predictable. The question then is, how to reconcile turbulence with classical physics?</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d11f19b8